import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import VehicleInfo from '../../components/VehicleInfo'
import Description from '../../components/Description'
import QuotedItem from '../../components/QuotedItem'

const Appointment = ({
  vehicle,
  timeSlot,
  emailModalData,
  store,
  orderId,
  isUpcomingAppointment,
  updateCancelAppointment,
  freeAlignmentCheckSku,
  quotedItemAndServices,
  printHandler,
  printable
}) =>
  <Wrapper data-at-myappointments-appointment printable={ printable }>
    <VehicleInfo
      vehicle={ vehicle }
      timeSlot={ timeSlot } />
    <RightBlock>
      <Description
        emailModalData={ emailModalData }
        store={ store }
        orderId={ orderId }
        isUpcomingAppointment={ isUpcomingAppointment }
        printHandler={ printHandler }
        updateCancelAppointment={ updateCancelAppointment } />
      <QuotedItem
        freeAlignmentCheckSku={ freeAlignmentCheckSku }
        quotedItemAndServices={ quotedItemAndServices } />
    </RightBlock>
  </Wrapper>

Appointment.propTypes = {
  emailModalData: PropTypes.shape(),
  freeAlignmentCheckSku: PropTypes.shape(),
  isUpcomingAppointment: PropTypes.bool,
  orderId: PropTypes.string,
  printable: PropTypes.bool,
  printHandler: PropTypes.func,
  quotedItemAndServices: PropTypes.shape(),
  store: PropTypes.shape(),
  timeSlot: PropTypes.shape(),
  updateCancelAppointment: PropTypes.arrayOf(PropTypes.shape()),
  vehicle: PropTypes.shape()
}

export default Appointment


const Wrapper = styled.div.attrs(({ printable }) => ({
  'data-printless': printable ? null : true
}))`
  display: table;
  width: 100%;

  & + & {
    margin-top: 40px;
  }
`

const RightBlock = styled.div`
  border: 1px solid ${Theme.colors.light_grey};
  ${Media.desktop`
    display: table-cell;
    vertical-align: bottom;
    border-left: none;
  `}
  ${Media.mobile`
    border-top: none;
  `}
`
